const PROJECT_ID = '4504400729276416';

export {PROJECT_ID};
